<div class="section-card">
  <div class="section-head">
    <span class="title">
      <i class="bi bi-clipboard2-check" style="color: var(--clug-primary);"></i>
      Awaiting Approvals
      <span class="count">{{ awaitingApprovalTimesheetsCount }}</span>
    </span>
    <a [routerLink]="" (click)="openAllAwaitingApprovals()" class="link-primary">
      See all <i class="bi bi-arrow-right"></i>
    </a>
  </div>

  <div class="section-list" *ngIf="awaitingApprovalTimesheets?.length; else emptyAwaiting">
    <div *ngFor="let timesheet of awaitingApprovalTimesheets; let i = index" class="list-item">
      <div class="avatar" (click)="redirect('/candidates', timesheet.candidate)">
        <img *ngIf="timesheet.profile_pic" [src]="dataSharedService.getImage(timesheet.profile_pic)"
          [alt]="timesheet.candidate" />
        <span *ngIf="!timesheet.profile_pic">
          {{ authService.getInitials(timesheet.candidate) }}
        </span>
      </div>

      <div class="meta">
        <div class="name-line">
          <a [routerLink]="" (click)="redirect('/candidates', timesheet.candidate)" class="name">
            {{ timesheet.candidate }}
          </a>
          <span class="hours" *ngIf="candidateTrackingHrs != 2">· {{ timesheet.total_hours }} hrs</span>
          <span class="hours" *ngIf="candidateTrackingHrs == 2">· {{ timesheet.total_days }} days</span>
        </div>
        <div class="sub">
          {{ timesheet.job }} · {{ timesheet.client }} ·
          {{ dataSharedService.tranformDate(timesheet.start_date) }} – {{
          dataSharedService.tranformDate(timesheet.end_date) }}
        </div>
      </div>

      <div class="right-chips">
        <!-- <button type="button" class="btn btn-primary review-btn"
          (click)="openTimesheetDetails(timesheet, timesheet.status, true)">
          Review
        </button> -->
        <button type="button" class="icon-btn-sm" title="Send reminder"
          (click)="openSendReminderPopUp(timesheet.client_uuid, timesheet.candidate, timesheet.job, timesheet.uuid, timesheet.agency_uuid)">
          <i class="bi bi-envelope"></i>
        </button>
      </div>
    </div>
  </div>

  <ng-template #emptyAwaiting>
    <div class="section-empty">
      <div class="ico"><i class="bi bi-check2-circle"></i></div>
      <h4>Nothing awaiting</h4>
      <p>You're all caught up on approvals.</p>
    </div>
  </ng-template>
</div>